import { render } from "./ViewAlaUne.vue?vue&type=template&id=000befac&ts=true"
import script from "./ViewAlaUne.vue?vue&type=script&lang=ts"
export * from "./ViewAlaUne.vue?vue&type=script&lang=ts"

import "./ViewAlaUne.vue?vue&type=style&index=0&id=000befac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__